<div class="member-list-container">
  <section class="member-list-section" [style.backgroundImage]="'url(' + back + ')'">
    <div class="overlay"></div>
    <div class="banner">
      <div class="member-list-content">
        <h1 class="title">Meet Hong Kong Singles - Members</h1>
      </div>
    </div>
  </section>
  <div class="main-container">
    <div class="members-section">
      <p class="alert">
        Please be aware your profile will not appear on the Members Page until
        you complete all of the fields in your
        <span>'Edit Profile'</span> section.
      </p>
      <div class="filters">
        <div class="fliter-flex">
          <p class="filter-btn">
            Click on this button below
            <span><img src="{{this.api.frontendAssetsUrl}}blue-button-filter.png" alt="filter-icon" width="56px"
                height="56px" /></span>to filter between men or women.
          </p>
        </div>
      </div>
      <div class="search-button">
        <div class="input">
          <input type="text" class="search-input" placeholder="Search Members..." [(ngModel)]="searchQuery"
            (input)="onSearchChange()" [style.backgroundImage]="'url(' + search + ')'" />
        </div>
        <div class="input-img">
          <img (click)="openFilter()" src="{{this.api.frontendAssetsUrl}}blue-button-filter.png" alt="filter-icon"
            width="56px" height="56px" />
        </div>
      </div>
    </div>
    <div class="members">
      <div class="member-list">
        <div *ngFor="let member of members" class="card">
          <div class="user-profile">
            <a (click)="view_member(member.username)">
              <img [src]="member.profile_pic" alt="{{ member.name }}" />
            </a>
          </div>
          <div class="user-detail">
            <h6 class="name">
              <a [routerLink]="['/member-profile',member.username,'Profile']">{{ member.username }}</a>
              <div class="status"
                [ngClass]="{ online: member.isOnline === 'true' || member.isOnline === true, offline: member.isOnline === 'false' || member.isOnline === false}">
              </div>
            </h6>
            <div class="user-detail-content">
              <p class="age">{{ member.age }}</p>
              <p class="gender-icon-container">
                <!-- <img *ngIf="member?.gender?.name === 'Male'" src="{{this.api.frontendAssetsUrl}}mars.png"
                  class="gender-icon" alt="male" width="20px" height="20px" />
                <img *ngIf="member?.gender?.name === 'Female'" src="{{this.api.frontendAssetsUrl}}femenine.png"
                  class="gender-icon" alt="female" width="20px" height="20px" /> -->

                  <fa-icon class="{{member?.gender?.name=='Others'?'others':''}}" [icon]="
    member?.gender?.name === 'Male' ? famale :
    member?.gender?.name === 'Female' ? fafemale :
    fatrans
  "></fa-icon>
              </p>
              <p class="location">{{ member.country?.name }}{{member.state?.name ? ',' : ''}} {{ member.state?.name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isLoading" class="shine"></div>
        <div *ngIf="isLoading" class="shine"></div>
        <div *ngIf="isLoading" class="shine"></div>
        <div *ngIf="isLoading" class="shine"></div>
        <div *ngIf="isLoading" class="shine"></div>
        <div *ngIf="isLoading" class="shine"></div>
        <div *ngIf="isLoading" class="shine"></div>
        <div *ngIf="isLoading" class="shine"></div>
      <div *ngIf="!isLoading && members.length === 0" class="no_found">
        <p>No record found for your search criteria.</p>
      </div>
    </div>
  </div>
  <app-filter #filterOverlay (memberdata)="setmemberdata($event)"></app-filter>
</div>